"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWidthEmpty = isWidthEmpty;
exports.isHeightEmpty = isHeightEmpty;
exports.isEmpty = isEmpty;
exports.isUnitSized = isUnitSized;
exports.jumpSelection = jumpSelection;
exports.moveSelection = moveSelection;
exports.moveSelectionInside = moveSelectionInside;
exports.pointExpandSelection = pointExpandSelection;
exports.pointInSelection = pointInSelection;
exports.resizeSelection = resizeSelection;
exports.refreshSelection = refreshSelection;
exports.shrinkSelectionToFitRegion = shrinkSelectionToFitRegion;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var mathUtils = _interopRequireWildcard(require("./mathUtils"));

function isWidthEmpty(selection) {
  return !selection || selection.right - selection.left <= 0;
}

function isHeightEmpty(selection) {
  return !selection || selection.bottom - selection.top <= 0;
}

function isEmpty(selection) {
  return isWidthEmpty(selection) && isHeightEmpty(selection);
}

function isUnitSized(selection) {
  var isWidthOne = selection.right - selection.left <= 1;
  var isHeightOne = selection.bottom - selection.top <= 1;
  return isWidthOne && isHeightOne;
}

function jumpSelection(selection, columns, rows) {
  var left = mathUtils.clamp(selection.left, 0, columns.length);
  var right = mathUtils.clamp(selection.right, 0, columns.length);
  var activeX = mathUtils.clamp(selection.activeX, 0, columns.length);
  var top = mathUtils.clamp(selection.top, 0, rows.length);
  var bottom = mathUtils.clamp(selection.bottom, 0, rows.length);
  var activeY = mathUtils.clamp(selection.activeY, 0, rows.length);
  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    activeX: activeX,
    activeY: activeY
  };
}
/**
 * Move a selection. The difference between moving a selection and shifting a selection is that
 *     moving a selection will resize it to a 1 by 1 region, while shifting preserves the original
 *     dimensions of the selection.
 * @param {Object} selection The selection object to move.
 * @param {Object[]} columns The list of columns. Used for determing when to wrap to the next row.
 * @param {Object[]} rows The list of rows. Used for determing when to wrap to the next column.
 * @param {number} x The number of columns to move the selection by to the right.
 * @param {number} y The number of rows to move the selection by to the bottom.
 * @returns {Object} The moved selection.
 */


function moveSelection(selection, columns, rows, x, y) {
  var carryX = mathUtils.carry(selection.activeX + x, 0, columns.length);
  var carryY = mathUtils.carry(selection.activeY + y, 0, rows.length);
  var columnIndex = mathUtils.wrap(selection.activeX + x + carryY, 0, columns.length);
  var rowIndex = mathUtils.wrap(selection.activeY + y + carryX, 0, rows.length);
  var left = columnIndex;
  var right = columnIndex + 1;
  var top = rowIndex;
  var bottom = rowIndex + 1;
  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    activeX: left,
    activeY: top
  };
}
/**
 * Move the active cell inside of a selection while maintaing the selection itself.
 * @param {Object} selection The selection object.
 * @param {number} x The number of columns to move the active cell by to the right.
 * @param {number} y The number of rows to move the active cell by to the bottom.
 * @returns {Object} The selection with the active cell moved.
 */


function moveSelectionInside(selection, x, y) {
  var boundLeft = selection.left,
      boundRight = selection.right,
      boundTop = selection.top,
      boundBottom = selection.bottom;
  var carryX = mathUtils.carry(selection.activeX + x, boundLeft, boundRight);
  var carryY = mathUtils.carry(selection.activeY + y, boundTop, boundBottom);
  var columnIndex = mathUtils.wrap(selection.activeX + x + carryY, boundLeft, boundRight);
  var rowIndex = mathUtils.wrap(selection.activeY + y + carryX, boundTop, boundBottom);
  return (0, _objectSpread2.default)({}, selection, {
    activeX: columnIndex,
    activeY: rowIndex
  });
}

function pointExpandSelection(selection, _ref, _ref2) {
  var x = _ref.x,
      y = _ref.y;
  var width = _ref2.width,
      height = _ref2.height;
  var left = selection.left,
      right = selection.right,
      activeX = selection.activeX;

  if (!(0, _isNil.default)(x) && width) {
    left = selection.left < x ? selection.left : selection.left + width;
    right = selection.right <= x ? selection.right : selection.right + width;
    activeX = selection.activeX < x ? selection.activeX : selection.activeX + width;
  }

  var top = selection.top,
      bottom = selection.bottom,
      activeY = selection.activeY;

  if (!(0, _isNil.default)(y) && height) {
    top = selection.top < y ? selection.top : selection.top + height;
    bottom = selection.bottom <= y ? selection.bottom : selection.bottom + height;
    activeY = selection.activeY < y ? selection.activeY : selection.activeY + height;
  }

  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    activeX: activeX,
    activeY: activeY
  };
}
/**
 * Checks to see if the point exists within a selection.
 * @param {Object} selection The selection object.
 * @param {number} x The horizontal component of the point.
 * @param {number} y The vertical component of the point.
 * @returns {boolean} True if the point is in the selection, false otherwise.
 */


function pointInSelection(selection, x, y) {
  var insideX = x >= selection.left && x < selection.right;
  var insideY = y >= selection.top && y < selection.bottom;
  return insideX && insideY;
}
/**
 * Resize a selection around the active cell.
 * Works by shrinking a side until it cannot be shrunk, and then growing the opposite side.
 * For example, resizing x by 1 would shrink and selection to the left of the active cell until
 *     the active cell is adjacent with the left border of the selection. Then, the right side of
 *     the active cell will be grown.
 * @param {Object} selection The selection object.
 * @param {Object[]} columns The list of columns. Used for determing when to stop growing.
 * @param {Object[]} rows The list of rows. Used for determing when to stop growing.
 * @param {number} x The amount to resize horizontally.
 * @param {number} y The amount to resize vertically.
 */


function resizeSelection(selection, columns, rows, x, y) {
  var left = selection.left,
      right = selection.right,
      top = selection.top,
      bottom = selection.bottom;

  if (x < 0) {
    var shouldGrow = selection.right === selection.activeX + 1;
    left = shouldGrow ? selection.left + x : selection.left;
    right = shouldGrow ? selection.right : selection.right + x;
  } else if (x > 0) {
    var _shouldGrow = selection.left === selection.activeX;

    left = _shouldGrow ? selection.left : selection.left + x;
    right = _shouldGrow ? selection.right + x : selection.right;
  }

  if (y < 0) {
    var _shouldGrow2 = selection.bottom === selection.activeY + 1;

    top = _shouldGrow2 ? selection.top + y : selection.top;
    bottom = _shouldGrow2 ? selection.bottom : selection.bottom + y;
  } else if (y > 0) {
    var _shouldGrow3 = selection.top === selection.activeY;

    top = _shouldGrow3 ? selection.top : selection.top + y;
    bottom = _shouldGrow3 ? selection.bottom + y : selection.bottom;
  }

  return jumpSelection((0, _objectSpread2.default)({}, selection, {
    left: left,
    right: right,
    top: top,
    bottom: bottom
  }), columns, rows);
}
/**
 * Return a valid selection if there is no current selection but there is room in the grid for one.
 * @param {Object} selection The current selection.
 * @param {Object[]} rows The list of rows.
 * @param {Object[]} columns The list of columns.
 * @returns {Object} A new selection if it is possible to place one.
 */


function refreshSelection(selection, columns, rows) {
  return selection === null && rows.length > 0 && columns.length > 0 ? {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    activeX: 0,
    activeY: 0
  } : selection;
}
/**
 * Resize the selection by specifying the amount to grow in specific directions.
 * @param {Object} selection The selection object.
 * @param {Object} move How much to resize by in each direction.
 * @returns {Object} A new selection resized by the given amounts.
 */


function shrinkResizeSelection(selection, move) {
  var _move$left = move.left,
      moveLeft = _move$left === void 0 ? 0 : _move$left,
      _move$right = move.right,
      moveRight = _move$right === void 0 ? 0 : _move$right,
      _move$top = move.top,
      moveTop = _move$top === void 0 ? 0 : _move$top,
      _move$bottom = move.bottom,
      moveBottom = _move$bottom === void 0 ? 0 : _move$bottom; // How much the different dimensions need to overflow by to affect the opposite side.

  var deltaX = selection.right - selection.left;
  var deltaY = selection.bottom - selection.top; // Determine the new coordinates of the selection

  var top = selection.top - moveTop - Math.min(0, deltaY + moveBottom);
  var right = selection.right + moveRight + Math.min(0, deltaX + moveLeft);
  var bottom = selection.bottom + moveBottom + Math.min(0, deltaY + moveTop);
  var left = selection.left - moveLeft - Math.min(0, deltaX + moveRight); // Clamp the active cell to the range of the new selection.

  var activeX = mathUtils.clamp(selection.activeX, left, right);
  var activeY = mathUtils.clamp(selection.activeY, top, bottom); // If the new selection is inside out, we no longer have a valid selection - return null.

  if (top >= bottom || left >= right) {
    return null;
  }

  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    activeX: activeX,
    activeY: activeY
  };
}

function shiftSelection(selection, x, y) {
  var left = selection.left + x;
  var right = selection.right + x;
  var top = selection.top + y;
  var bottom = selection.bottom + y;
  var activeX = selection.activeX + x;
  var activeY = selection.activeY + y;
  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    activeX: activeX,
    activeY: activeY
  };
}

function shrinkSelectionToFitRegion(selection, region) {
  // Shift the selection up and left if the selection extends beyond the region's bottom left corner.
  var shiftX = Math.min(0, region.right - selection.right);
  var shiftY = Math.min(0, region.bottom - selection.bottom);
  var shifted = shiftSelection(selection, shiftX, shiftY); // Collapse the selection's top and left sides to fit the containing region.

  var collapseX = Math.min(0, shifted.left - region.left);
  var collapseY = Math.min(0, shifted.top - region.top);
  var resized = shrinkResizeSelection(shifted, {
    left: collapseX,
    top: collapseY
  });
  return resized;
}